const isDemoMode = import.meta.env.VITE_DEMO_MODE === 'true';

export { isDemoMode };

export function DemoBanner() {
  if (!isDemoMode) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[200] h-8 flex items-center justify-center bg-amber-400 dark:bg-amber-500 text-amber-950 dark:text-amber-950 text-xs font-semibold tracking-wide px-4 gap-2"
      role="banner"
      data-testid="banner-demo-mode"
    >
      <span className="inline-block w-2 h-2 rounded-full bg-amber-700 dark:bg-amber-800 shrink-0" aria-hidden="true" />
      Demo Environment — For investor preview only · Not for clinical use
    </div>
  );
}
